import { format } from "date-fns";
import { useMemo } from "react";

// Builds URLSearchParams with period param (yyyy-MM-01) for export APIs. Example:
// ?period=2026-02-01
export const usePeriodQueryParams = (month: Date): URLSearchParams =>
  useMemo(() => {
    const params = new URLSearchParams();
    params.append("period", format(month, "yyyy-MM-01"));
    return params;
  }, [month]);
